<template>
  <div>
    <v-stepper-step
      :step="2"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(2)"
      :editable="(!isViewOredit && isStepCompleted(2)) || edit"
      :rules="[() => currentStep < 3 || !!templateData.name, () => !showNameError ]"
      edit-icon="$complete"
    >
      {{$t('commonWords.name')}}
      <small v-if="isStepCompleted(2) && currentStep !== 2" class="mt-2">{{ templateData.name }}</small>
    </v-stepper-step>
    <v-stepper-content :step="2">
      <v-text-field
        v-model="templateData.name"
        :label="$t('templates.name')"
        @input="validateIfNameIsUnique($event)"
        :error="showNameError"
        :error-messages="showNameError ? $t('campaign.duplicatedName') : ''"
        :rules="[() => !!templateData.name || $t('commonPhrases.requiredField') ]"
        required
      />
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='nextStep()'
          :disabled="inputIsNull(templateData.name) || showNameError"
        >
          {{$t('commonWords.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()' v-if="method !== 'view' && !edit">
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="3"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(3)"
      :editable="(!isViewOredit && isStepCompleted(3)) || edit"
      :rules="[() => currentStep < 4 || !!templateData.text]"
      edit-icon="$complete"
    >
      {{$t('commonWords.message')}}
      <span v-if="currentStep === 3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size='14'
              v-bind="attrs"
              v-on="on"
            >mdi-information-outline
            </v-icon>
          </template>
          <span style="font-size: 10px">{{$t('templates.smsLimitCharacter')}}</span>
        </v-tooltip>
      </span>
      <small v-if="isStepCompleted(3) && currentStep !== 3" class="mt-2" v-html="templateData.text" />
    </v-stepper-step>
    <v-stepper-content :step="3">
      <text-editor
        @change="templateData.text = $event"
        :value="template.text"
        :disabled="method === 'view'"
        :label="$t('templateEditDialog.text')"
        :maxLength="160"
        showCounter
        onlyText
        required
        class="margin-bottom"
      />
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='completeStep()'
          :disabled="inputIsNull(templateData.text)"
        >
          {{$t('commonWords.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()' v-if="method !== 'view' || edit">
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <div class="v-card-actions text-right" style="margin-right: 20px" v-if="(edit || stepperCompleted) && method !== 'view'" >
      <v-btn
        v-if="(edit || stepperCompleted) && method !== 'view'"
        text
        style="margin-right: 10px"
        @click="$emit('close')"
      >{{ $t('commonWords.cancel') }}</v-btn>
      <v-btn
        color="#43a047"
        style="color: white;"
        :loading="loading"
        :disabled="loading"
        @click="$emit('createTemplate',templateData)"
      >
        {{saveOrCreateButtonText}}
      </v-btn>
    </div>
  </div>
</template>

<script>
import TextEditor from '@/components/TextEditor.vue'
import debounce from 'lodash.debounce'

export default {
  name: 'SmsSteps',
  components: {
    TextEditor
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    currentStep: {
      type: Number
    },
    stepperCompleted: {
      type: Boolean,
      default: false
    },
    method: {
      type: String
    },
    isViewOredit: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showNameError: false,
      templateData: {
        name: null,
        text: null
      }
    }
  },
  created () {
    if (this.template) {
      this.templateData = {
        name: this.template.name,
        text: this.template.text
      }
    }
  },
  computed: {
    saveOrCreateButtonText () {
      return this.edit ? this.$t('commonWords.save') : this.$t('commonWords.create')
    }
  },
  methods: {
    inputIsNull (inputValue) {
      return inputValue === null || String(inputValue).trim() === ''
    },
    nextStep () {
      this.$emit('nextStep')
    },
    prevStep () {
      this.$emit('prevStep')
    },
    completeStep () {
      this.$emit('completeStep')
    },
    isStepCompleted (step) {
      if (this.edit) {
        return true
      }
      return step < this.currentStep
    },
    validateIfNameIsUnique: debounce(async function () {
      try {
        await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/validation-name`, {
          params: {
            name: this.templateData.name
          }
        })
        this.showNameError = false
      } catch (e) {
        this.showNameError = true
      }
    }, 500)
  }
}
</script>

<style lang="scss">
  .margin-bottom {
    margin-bottom: 1rem;
  }
</style>
